<!-- =========================================================================================
    File Name: ApexCharts.vue
    Description: Apex Charts Demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="extra-component-chartist-demo">
    <div class="vx-row d-flex justify-center ">
      <div class="vx-col  w-50 mb-base text-center">
        <!-- <vx-card title="Column Chart" class="text-center" code-toggler> -->
        <h1>Select Person</h1>
        <small>
          ** all the info related to the person you selected will be available
          for you
        </small>
        <v-select
          class="w-50"
          :options="peopleNames"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-model="selectedPerson"
        />
        <!-- <v-select
            :options="[{ label: 'Foo', value: 'foo' }]"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          /> -->
        <!-- </vx-card> -->
      </div>
    </div>
    <!-- general statics -->
    <div class="vx-row">
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="EyeIcon"
          statistic="15 Days"
          statisticTitle="Logged to the app"
        />
      </div>

      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="MessageSquareIcon"
          statisticTitle="Meeting"
          statistic="3"
          color="success"
        />
      </div>

      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="ShoppingBagIcon"
          statistic="85"
          statisticTitle="Ordered Meal"
          color="warning"
        />
      </div>

      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="HeartIcon"
          statistic="10 Hours"
          statisticTitle="Exercise"
          color="danger"
        />
      </div>

      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="SmileIcon"
          statistic="4"
          statisticTitle="Posts"
          color="success"
        />
      </div>

      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DropletIcon"
          statistic="2 cup"
          statisticTitle="Water"
          color="warning"
        />
      </div>
    </div>
    <div class="vx-row">
      <!-- COLUMN CHART -->
      <div class="vx-col  w-full mb-base">
        <vx-card title="Column Chart" code-toggler>
          <vue-apex-charts
            type="bar"
            height="350"
            :options="apexChatData.columnChart.chartOptions"
            :series="apexChatData.columnChart.series"
          ></vue-apex-charts>
          <template slot="codeContainer">
            {{ apexChatData.columnChartCode }}
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import apexChatData from "./apexChartData.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
      apexChatData,
      lineChartSimplePercentSeries: [],
      selectedPerson: "لبنى خالد",
      peopleNames: [
        "ريما فرنسيس",
        "منى جابر",
        "امل فلوس",
        "أميرة محمد مصري",
        "دعاء زريقات",
        "Manar Saada",
        "امال اون لاين",
        "امل تيتي",
        "eiman amoor",
        "لينا شداد",
        "رشا محمد محمد ايوب",
        "شيرين قدح",
        "اسماء محمد",
        "Maisoon Bsoul",
        "Musab Abdel Hafez",
        "الاء محمد قنعير",
        "سهير خوري",
        "نزهه صالح",
        "نور صالح",
        "اصالة مصطفى نصار",
        "زينب خالد مصاروة",
        "ضحى علي قبند",
        "دعاء جبارين",
        "سهى ابو الهيجاء",
        "سما يعيش",
        "رشا نبراوي",
        "غزاله ابو صيام",
        "مسك رسمي بيادسة",
        "ايه حاج يحيى",
        "rasha telhami",
        "حنان ابومخ",
        "ريم رفاعي",
        "منى خازم",
        "مريم سلامه",
        "اماني احمد سليمان",
        "رنين لحام",
        "ياسمين وتد",
        "فاطمه عكاوي",
        "نورا شهوان",
        "فاتن= دراوشة",
        "نهاية عطية",
        "لورين شريف",
        "منار مراعنة",
        "شفاء مرعي",
        "مرام عبد الهادي",
        "ختام الحاج",
        "عدن بلبل",
        "فاطمة شناوي",
        "ليلى محاميد",
        "نداء ابو ريا",
        "امنه= عبد الرحمان دقه",
        "هبة ابو مخ",
        "رشا أبو شهوان",
        "ياسمين جمل",
        "أحمد أبو فرحة",
        "رابعة",
        "احلام زرازير",
        "مرفت عيسى احمد عوده",
        "Marah Shattawi",
        "الاء قعدان",
        "ميسون رجب امارة",
        "ثروت حماد",
        "نبيهه وتد",
        "رانيه مسعود",
        "نهيل خلف",
        "raheeq ashkar",
        "جنان غانم",
        "احلام مصطفى",
        "نيداء= محمود"
      ]
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    "v-select": vSelect
  },
  mounted() {
    const arr = this.apexChatData.lineChartSimpleWeight.series;
    for (let index = 0; index < arr.length; index++) {
      const series = arr[index].data;
      const tempData = [];

      for (let i = series.length - 1; i >= 0; i--) {
        const chg =
          ((series[i] - series[series.length - 1]) /
            series[series.length - 1]) *
          100;

        tempData.push(Number(chg.toPrecision(2)));
      }
      this.lineChartSimplePercentSeries.push({
        name: arr[index].name,
        data: tempData
      });
    }
  }
};
</script>
